import { FlightCard } from '@/src/types/flight'

export const cardGrouping = (selectedLegSortedFilteredCards: FlightCard[], shouldShowMultiAirlinePrices: boolean) => {
    return selectedLegSortedFilteredCards?.length < 5000 //temporary we are disabling the card grouping for now , so  setting a large number to disable the grouping
        ? selectedLegSortedFilteredCards.map((card, idx) => {
              const key = card.id ?? idx
              return [`linear_${String(key)}_${idx}`, [card]] as [string, FlightCard[]]
          })
        : Object.entries(
              selectedLegSortedFilteredCards.reduce((acc: Record<string, FlightCard[]>, card: FlightCard) => {
                  const airlineKey =
                      Array.isArray(card.airlineCodes) && card.airlineCodes.length > 0 ? card.airlineCodes[0] : ''
                  const groupKey = `${airlineKey}_${String(shouldShowMultiAirlinePrices ? card.priceBreakup?.multiAirlinePrice : card.priceBreakup?.pr)}`
                  if (!acc[groupKey]) acc[groupKey] = []
                  acc[groupKey].push(card)
                  return acc
              }, {})
          )
}
